import type { AuthResponse } from '../types';
import { homeFor } from '@/app/router/homes';
import { useSession } from '@/app/store/session.store';
import { setAccessToken } from '@/shared/api/httpClient';

/** Applies an auth response to the client session and returns where to go next. */
export function startSession(res: AuthResponse): string {
  setAccessToken(res.accessToken);
  useSession.getState().setSession(res.user, res.accessToken);
  return homeFor(res.user.role);
}

export function endSession(): void {
  setAccessToken(null);
  useSession.getState().clear();
}

const REMEMBER_KEY = 'syncra.remember';

export function readRemember(): boolean {
  try {
    return localStorage.getItem(REMEMBER_KEY) !== 'false';
  } catch {
    return true;
  }
}

export function writeRemember(value: boolean): void {
  try {
    localStorage.setItem(REMEMBER_KEY, String(value));
  } catch {
    /* storage unavailable: remembering is a convenience only */
  }
}
